import { markRaw } from 'vue'

export default class Tool {
  constructor (context) {
    const { canvas, canvas_cursor, cursor, mouse, value } = context
    this.canvas = canvas
    this.canvas_cursor = canvas_cursor
    this.cursor = cursor
    this.mouse = mouse
    this.value = value

    this.context = context
  }

  lerp (a, b, n) {
    return (1 - n) * a + n * b
  }
}

export class ToolSetting {
  constructor ({ value, options, render }) {
    this.value = value
    this.options = options
    this.render = render
  }

  get component () {
    const that = this

    return markRaw({
      data () {
        return {
          value: that.value,
          options: that.options,
        }
      },
      methods: {
        set (val) {
          this.value = val
          that.value = val
        },
      },
      render () {
        return that.render ? that.render.call(this) : null
      },
    })
  }

  get showSettings () {
    return false
  }
}
